/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {GetLcdSubscriptionsRequest} from '../models/GetLcdSubscriptionsRequest';
import type {RegionSettings} from '../models/RegionSettings';
import type {UpdateUserLcdSubscriptionsRequest} from '../models/UpdateUserLcdSubscriptionsRequest';

export interface GetBatchUserSubscriptions$Request {
    getLcdSubscriptionsRequest: GetLcdSubscriptionsRequest;
}

export interface GetBatchUserSubscriptions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getBatchUserSubscriptionsRequest = createAction<PayloadData<void, GetBatchUserSubscriptions$Request>>('USER_LCD_SUBSCRIPTIONS__GET_BATCH_USER_SUBSCRIPTIONS__REQUEST');
export const getBatchUserSubscriptionsSuccess = createAction<PayloadData<{ [key: string]: { [key: string]: Array<RegionSettings>; }; }, GetBatchUserSubscriptions$Request>>('USER_LCD_SUBSCRIPTIONS__GET_BATCH_USER_SUBSCRIPTIONS__SUCCESS');
export const getBatchUserSubscriptionsFailure = createAction<PayloadData<Error, GetBatchUserSubscriptions$Request, true>>('USER_LCD_SUBSCRIPTIONS__GET_BATCH_USER_SUBSCRIPTIONS__FAILURE');

export const getBatchUserSubscriptionsActions = [
    getBatchUserSubscriptionsRequest,
    getBatchUserSubscriptionsSuccess,
    getBatchUserSubscriptionsFailure
] as const;

/**
 * @param {GetLcdSubscriptionsRequest} meta.getLcdSubscriptionsRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getBatchUserSubscriptions = (meta: GetBatchUserSubscriptions$Request, config?: GetBatchUserSubscriptions$Config) => {
    return {
        CALL_API: {
            types: getBatchUserSubscriptionsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/lcd-subscriptions/batch`,
            TRANSPORT_REQUEST_BODY: meta.getLcdSubscriptionsRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUserSubscriptions$Request {
    userId: number;
}

export interface GetUserSubscriptions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserSubscriptionsRequest = createAction<PayloadData<void, GetUserSubscriptions$Request>>('USER_LCD_SUBSCRIPTIONS__GET_USER_SUBSCRIPTIONS__REQUEST');
export const getUserSubscriptionsSuccess = createAction<PayloadData<{ [key: string]: Array<RegionSettings>; }, GetUserSubscriptions$Request>>('USER_LCD_SUBSCRIPTIONS__GET_USER_SUBSCRIPTIONS__SUCCESS');
export const getUserSubscriptionsFailure = createAction<PayloadData<Error, GetUserSubscriptions$Request, true>>('USER_LCD_SUBSCRIPTIONS__GET_USER_SUBSCRIPTIONS__FAILURE');

export const getUserSubscriptionsActions = [
    getUserSubscriptionsRequest,
    getUserSubscriptionsSuccess,
    getUserSubscriptionsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserSubscriptions = (meta: GetUserSubscriptions$Request, config?: GetUserSubscriptions$Config) => {
    return {
        CALL_API: {
            types: getUserSubscriptionsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/lcd-subscriptions`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateUserSubscriptions$Request {
    userId: number;
    updateUserLcdSubscriptionsRequest?: UpdateUserLcdSubscriptionsRequest;
}

export interface UpdateUserSubscriptions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateUserSubscriptionsRequest = createAction<PayloadData<void, UpdateUserSubscriptions$Request>>('USER_LCD_SUBSCRIPTIONS__UPDATE_USER_SUBSCRIPTIONS__REQUEST');
export const updateUserSubscriptionsSuccess = createAction<PayloadData<void, UpdateUserSubscriptions$Request>>('USER_LCD_SUBSCRIPTIONS__UPDATE_USER_SUBSCRIPTIONS__SUCCESS');
export const updateUserSubscriptionsFailure = createAction<PayloadData<Error, UpdateUserSubscriptions$Request, true>>('USER_LCD_SUBSCRIPTIONS__UPDATE_USER_SUBSCRIPTIONS__FAILURE');

export const updateUserSubscriptionsActions = [
    updateUserSubscriptionsRequest,
    updateUserSubscriptionsSuccess,
    updateUserSubscriptionsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UpdateUserLcdSubscriptionsRequest} [meta.updateUserLcdSubscriptionsRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateUserSubscriptions = (meta: UpdateUserSubscriptions$Request, config?: UpdateUserSubscriptions$Config) => {
    return {
        CALL_API: {
            types: updateUserSubscriptionsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/lcd-subscriptions`,
            TRANSPORT_REQUEST_BODY: meta.updateUserLcdSubscriptionsRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

